<div class="doctor-container">
  <!-- Filtros de Gestão de Médicos -->
  <div class="filters-section">
    <mat-card class="filters-card">
      <mat-card-title class="filters-header">
        <div class="title-section">
          <mat-icon class="filter-icon">filter_list</mat-icon>
          <span>Gestão de Médicos</span>
          @if (hasActiveFilters()) {
            <span class="filter-indicator">
              <mat-icon>fiber_manual_record</mat-icon>
              Ativos
            </span>
          }
        </div>
        <button mat-icon-button (click)="toggleFilters()" class="toggle-filters">
          <mat-icon>{{filtersExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </button>
      </mat-card-title>
      
      @if (filtersExpanded) {
        <mat-card-content class="filters-content">
          <div class="filters-grid">
            <!-- UF dos Médicos -->
            <app-searchable-select
              class="filter-field"
              [options]="ufOptions"
              [selected]="selectedMedicosUfs.value || []"
              (selectedChange)="selectedMedicosUfs.setValue($event)"
              label="UF"
              icon="location_on"
              hint="Selecione UFs dos médicos"
              [multiple]="true">
            </app-searchable-select>

            <!-- Status dos Médicos -->
            <app-searchable-select
              class="filter-field"
              [options]="medicosStatusOptions"
              [selected]="selectedMedicosStatus.value || []"
              (selectedChange)="selectedMedicosStatus.setValue($event)"
              label="Status dos Médicos"
              icon="toggle_on"
              hint="Selecione status dos médicos"
              [multiple]="true">
            </app-searchable-select>

            <!-- Especialidade -->
            <app-searchable-select
              class="filter-field"
              [options]="especialidadeOptions"
              [selected]="selectedEspecialidades.value || []"
              (selectedChange)="selectedEspecialidades.setValue($event)"
              label="Especialidade"
              icon="medical_services"
              hint="Selecione uma ou mais especialidades"
              [multiple]="true">
            </app-searchable-select>

            <!-- Status dos Resgates -->
            <app-searchable-select
              class="filter-field"
              [options]="medicosStatusResgates"
              [selected]="selectedResgates.value || []"
              (selectedChange)="selectedResgates.setValue($event)"
              label="Status de Resgate"
              icon="toggle_on"
              hint="Selecione os status de resgate"
              [multiple]="true">
            </app-searchable-select>
          </div>
          
          <div class="filter-actions">
            <button mat-raised-button color="primary" (click)="getDoctors()" class="search-btn">
              <mat-icon>search</mat-icon>
              Pesquisar
            </button>
            <button mat-stroked-button (click)="clearFilters()" class="clear-btn">
              <mat-icon>refresh</mat-icon>
              Limpar Filtros
            </button>
          </div>
        </mat-card-content>
      }
    </mat-card>
  </div>

  <!-- Cards de Resumo de Médicos -->
  <!--<div class="summary-cards">
    <mat-card class="summary-card">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>person</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{formatNumber(filteredStats.totalMedicos)}}</div>
          <div class="card-label">Total de Médicos</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="card-icon active">
          <mat-icon>check_circle</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{formatNumber(filteredStats.medicosAtivos)}}</div>
          <div class="card-label">Médicos Ativos</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="card-icon inactive">
          <mat-icon>cancel</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{formatNumber(filteredStats.medicosInativos)}}</div>
          <div class="card-label">Médicos Inativos</div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>-->

  <!-- Tabela de Médicos -->
  <div class="doctors-table-section">
    <mat-card class="table-card">
      @if(loading){
          <div class="page-loader"> 
            <mat-spinner></mat-spinner>
          </div>
        }@else{
          <mat-card-title style="padding: 16px; display: flex; justify-content: space-between; align-items: center;">
              <h3>Lista de Médicos</h3>
              <button class="crud-btn" (click)="downloadReport()" matFab extended style="min-width: 200px; margin-right: 16px;">
                <mat-icon>file_download</mat-icon>
                Exportar para Excel
              </button>
          </mat-card-title>
          <mat-card-content>
        
          <table mat-table [dataSource]="paginatedDataSource" class="doctor-table">
            <ng-container matColumnDef="uf">
              <th mat-header-cell *matHeaderCellDef>UF</th>
              <td mat-cell *matCellDef="let row">{{ row.uf }}</td>
            </ng-container>

            <!-- CRM -->
            <ng-container matColumnDef="crm">
              <th mat-header-cell *matHeaderCellDef>CRM</th>
              <td mat-cell *matCellDef="let row">{{ row.crm }}</td>
            </ng-container>

            <!-- Nome -->
            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let row">{{ row.nome }}</td>
            </ng-container>

            <!-- Especialidade -->
            <ng-container matColumnDef="especialidade">
              <th mat-header-cell *matHeaderCellDef>Especialidade Principal</th>
              <td mat-cell *matCellDef="let row">
                {{ row.especialidades?.split('- RQE')[0].toUpperCase() || 'N/A' }}
              </td>
            </ng-container>

            <!-- STATUS -->
            <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row" class="align-center">
              <span
                [ngClass]="row.status ? 'status-ativo' : 'status-inativo'">
                <mat-icon [class.success]="row.status" [class.warn]="!row.status">
                  {{ row.status ? 'check' : 'close' }}
                </mat-icon>
              </span>
            </td>
            </ng-container>


            <ng-container matColumnDef="pedido">
              <th mat-header-cell *matHeaderCellDef>Pedido</th>
              <td mat-cell *matCellDef="let row" class="align-center">
                <span
                  >
                  <mat-icon [style.color]="row.pedido_data ? '#b90066' : '#c2c2c2'"
                    [matTooltip]="row.pedido_data ? 'Já solicitado' : 'Não solicitado'"
                  >sell</mat-icon>
                </span>
              </td>
            </ng-container>

            <mat-icon>sell</mat-icon>
            <!-- Ações -->
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button color="primary" (click)="verDetalhes(row)">
                  <mat-icon matTooltip="Visulizar dados">visibility</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          
          <!-- Paginação -->
          <mat-paginator 
            [length]="getTotalItems()"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [pageIndex]="pageIndex"
            (page)="onPageChange($event)"
            showFirstLastButtons
            aria-label="Selecione a página de médicos">
          </mat-paginator>
        
      </mat-card-content>
    }
    </mat-card>
  </div>
</div>
